/**
 * Basic slider using Slick Slider
 * @see http://kenwheeler.github.io/slick/
 *
 * @author Erik Jan Lam
 * @date Nov 21 2018
 */

var $ = require('jquery');
require('slick-carousel');

var defaults = {
    lazyLoad: 'ondemand',
    infinite: false,
    dotsClass: 'slider-dots'
};

exports.init = function (element, settings) {
    var options = $.extend({}, defaults, settings || {});
    $(element).slick(options);
};
